import { useEffect } from "react";

export const useClickOutsideClose = (
    isDrawerOpen: boolean,
    drawerRef: React.RefObject<HTMLDivElement | null>,
    setIsDrawerOpen: (val: boolean) => void
) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (drawerRef.current && !drawerRef.current.contains(event.target as Node)) {
                setIsDrawerOpen(false);
            }
        };
        if (isDrawerOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isDrawerOpen, drawerRef, setIsDrawerOpen]);
};